// @flow

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import type { Element } from 'react';
import styled from 'styled-components';
import theme from '../../themes';

type Props = {
  id: string,
  children: string | Element<*> | Array<Element<*>>;
  in: boolean;
};

const Modal = styled.div`
  bottom: 0;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 65535;
  display: ${({ show }) => show ? 'block' : 'none'};
  ${theme.Modal};
`;

export class ModalContainer extends Component {
  render = () => null;
  modalEl = null;

  componentWillMount() {
    const { id = 'modal' } = this.props;

    let modalEl = id && document.getElementById(id);

    if (!modalEl) {
      modalEl = document.createElement('div');
      modalEl.id = id;
      if (document.body) {
        document.body.appendChild(modalEl);
      }
    }

    this.modalEl = modalEl;
  }

  componentWillUnmount() {
    if (this.modalEl) {
      this.modalEl.remove();
      this.modalEl = null;
    }
  }

  componentDidUpdate() {
    ReactDOM.render((
      <div>
        {this.props.children}
      </div>
    ), this.modalEl);
  }
}

export default class extends Component<Props, void> {
  render() {
    const { id, show, children } = this.props;

    return (
      <ModalContainer id={id}>
        <Modal show={show}>
          {children}
        </Modal>
      </ModalContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/modal.js